var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 0H0V6.30303H6.30303V0Z",
    fill: "#0B0C0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 0H6.30303V6.30303H12.6061V0Z",
    fill: "#0B0C0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 0H12.6061V6.30303H18.9091V0Z",
    fill: "#0B0C0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 0H18.9091V6.30303H25.2121V0Z",
    fill: "#0B0C0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 0H25.2121V6.30303H31.5152V0Z",
    fill: "#0B0C0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 0H31.5152V6.30303H37.8182V0Z",
    fill: "#0B0C0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 0H37.8182V6.30303H44.1212V0Z",
    fill: "#0B0C0D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 0H50.4242V6.30303H56.7273V0Z",
    fill: "#0B0C0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 0H56.7273V6.30303H63.0303V0Z",
    fill: "#0B0C0D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 0H69.3333V6.30303H75.6364V0Z",
    fill: "#0B0C0D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 0H75.6364V6.30303H81.9394V0Z",
    fill: "#0B0C0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 0H88.2424V6.30303H94.5455V0Z",
    fill: "#0B0C0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 0H100.848V6.30303H107.152V0Z",
    fill: "#0B0C0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 0H107.152V6.30303H113.455V0Z",
    fill: "#0B0C0D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 0H113.455V6.30303H119.758V0Z",
    fill: "#0B0C0D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 0H119.758V6.30303H126.061V0Z",
    fill: "#0B0C0D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 0H132.364V6.30303H138.667V0Z",
    fill: "#0B0C0D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 0H151.273V6.30303H157.576V0Z",
    fill: "#0B0C0D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 0H163.879V6.30303H170.182V0Z",
    fill: "#0B0C0D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 0H170.182V6.30303H176.485V0Z",
    fill: "#0B0C0D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 0H176.485V6.30303H182.788V0Z",
    fill: "#0B0C0D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 0H182.788V6.30303H189.091V0Z",
    fill: "#0B0C0D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 0H189.091V6.30303H195.394V0Z",
    fill: "#0B0C0D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 0H195.394V6.30303H201.697V0Z",
    fill: "#0B0C0D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M208 0H201.697V6.30303H208V0Z",
    fill: "#0B0C0D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 6.30303H0V12.6061H6.30303V6.30303Z",
    fill: "#0B0C0D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 6.30303H37.8182V12.6061H44.1212V6.30303Z",
    fill: "#0B0C0D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 6.30303H69.3333V12.6061H75.6364V6.30303Z",
    fill: "#0B0C0D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 6.30303H75.6364V12.6061H81.9394V6.30303Z",
    fill: "#0B0C0D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 6.30303H81.9394V12.6061H88.2424V6.30303Z",
    fill: "#0B0C0D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 6.30303H94.5455V12.6061H100.848V6.30303Z",
    fill: "#0B0C0D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 6.30303H107.152V12.6061H113.455V6.30303Z",
    fill: "#0B0C0D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 6.30303H119.758L119.758 12.6061H126.061V6.30303Z",
    fill: "#0B0C0D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 6.30303H132.364V12.6061H138.667V6.30303Z",
    fill: "#0B0C0D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 6.30303H144.97V12.6061H151.273V6.30303Z",
    fill: "#0B0C0D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 6.30303H163.879V12.6061H170.182V6.30303Z",
    fill: "#0B0C0D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M208 6.30303H201.697V12.6061H208V6.30303Z",
    fill: "#0B0C0D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 12.6061H0V18.9091H6.30303V12.6061Z",
    fill: "#0B0C0D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 12.6061H12.6061V18.9091H18.9091V12.6061Z",
    fill: "#0B0C0D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 12.6061H18.9091V18.9091H25.2121V12.6061Z",
    fill: "#0B0C0D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 12.6061H25.2121V18.9091H31.5152V12.6061Z",
    fill: "#0B0C0D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 12.6061H37.8182V18.9091H44.1212V12.6061Z",
    fill: "#0B0C0D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 12.6061H50.4242V18.9091H56.7273V12.6061Z",
    fill: "#0B0C0D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 12.6061H75.6364V18.9091H81.9394V12.6061Z",
    fill: "#0B0C0D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 12.6061H81.9394V18.9091H88.2424V12.6061Z",
    fill: "#0B0C0D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 12.6061H107.152V18.9091H113.455V12.6061Z",
    fill: "#0B0C0D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 12.6061H113.455V18.9091H119.758L119.758 12.6061Z",
    fill: "#0B0C0D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 12.6061H126.061V18.9091H132.364V12.6061Z",
    fill: "#0B0C0D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 12.6061H132.364V18.9091H138.667V12.6061Z",
    fill: "#0B0C0D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 12.6061H138.667V18.9091H144.97V12.6061Z",
    fill: "#0B0C0D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 12.6061H144.97V18.9091H151.273V12.6061Z",
    fill: "#0B0C0D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 12.6061H163.879V18.9091H170.182V12.6061Z",
    fill: "#0B0C0D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 12.6061H176.485V18.9091H182.788V12.6061Z",
    fill: "#0B0C0D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 12.6061H182.788V18.9091H189.091V12.6061Z",
    fill: "#0B0C0D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 12.6061H189.091V18.9091H195.394V12.6061Z",
    fill: "#0B0C0D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M208 12.6061H201.697V18.9091H208V12.6061Z",
    fill: "#0B0C0D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 18.9091H0V25.2121H6.30303V18.9091Z",
    fill: "#0B0C0D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 18.9091H12.6061V25.2121H18.9091V18.9091Z",
    fill: "#0B0C0D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 18.9091H18.9091V25.2121H25.2121V18.9091Z",
    fill: "#0B0C0D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 18.9091H25.2121V25.2121H31.5152V18.9091Z",
    fill: "#0B0C0D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 18.9091H37.8182V25.2121H44.1212V18.9091Z",
    fill: "#0B0C0D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 18.9091H50.4242V25.2121H56.7273V18.9091Z",
    fill: "#0B0C0D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 18.9091H63.0303V25.2121H69.3333V18.9091Z",
    fill: "#0B0C0D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 18.9091H100.848V25.2121H107.152V18.9091Z",
    fill: "#0B0C0D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 18.9091H107.152V25.2121H113.455V18.9091Z",
    fill: "#0B0C0D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 18.9091H119.758L119.758 25.2121H126.061V18.9091Z",
    fill: "#0B0C0D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 18.9091H132.364V25.2121H138.667V18.9091Z",
    fill: "#0B0C0D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 18.9091H138.667V25.2121H144.97V18.9091Z",
    fill: "#0B0C0D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 18.9091H151.273V25.2121H157.576V18.9091Z",
    fill: "#0B0C0D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 18.9091H163.879V25.2121H170.182V18.9091Z",
    fill: "#0B0C0D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 18.9091H176.485V25.2121H182.788V18.9091Z",
    fill: "#0B0C0D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 18.9091H182.788V25.2121H189.091V18.9091Z",
    fill: "#0B0C0D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 18.9091H189.091V25.2121H195.394V18.9091Z",
    fill: "#0B0C0D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M208 18.9091H201.697V25.2121H208V18.9091Z",
    fill: "#0B0C0D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 25.2121H0V31.5152H6.30303V25.2121Z",
    fill: "#0B0C0D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 25.2121H12.6061V31.5152H18.9091V25.2121Z",
    fill: "#0B0C0D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 25.2121H18.9091V31.5152H25.2121V25.2121Z",
    fill: "#0B0C0D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 25.2121H25.2121V31.5152H31.5152V25.2121Z",
    fill: "#0B0C0D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 25.2121H37.8182V31.5152H44.1212V25.2121Z",
    fill: "#0B0C0D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 25.2121H94.5455V31.5152H100.848V25.2121Z",
    fill: "#0B0C0D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 25.2121H107.152V31.5152H113.455V25.2121Z",
    fill: "#0B0C0D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 25.2121H163.879V31.5152H170.182V25.2121Z",
    fill: "#0B0C0D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 25.2121H176.485V31.5152H182.788V25.2121Z",
    fill: "#0B0C0D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 25.2121H182.788V31.5152H189.091V25.2121Z",
    fill: "#0B0C0D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 25.2121H189.091V31.5152H195.394V25.2121Z",
    fill: "#0B0C0D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M208 25.2121H201.697V31.5152H208V25.2121Z",
    fill: "#0B0C0D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 31.5152H0V37.8182H6.30303V31.5152Z",
    fill: "#0B0C0D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 31.5152H37.8182V37.8182H44.1212V31.5152Z",
    fill: "#0B0C0D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 31.5152H50.4242V37.8182H56.7273V31.5152Z",
    fill: "#0B0C0D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 31.5152H81.9394V37.8182H88.2424V31.5152Z",
    fill: "#0B0C0D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 31.5152H119.758V37.8182H126.061V31.5152Z",
    fill: "#0B0C0D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 31.5152H126.061V37.8182H132.364V31.5152Z",
    fill: "#0B0C0D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 31.5152H144.97V37.8182H151.273V31.5152Z",
    fill: "#0B0C0D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 31.5152H151.273V37.8182H157.576V31.5152Z",
    fill: "#0B0C0D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 31.5152H163.879V37.8182H170.182V31.5152Z",
    fill: "#0B0C0D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M208 31.5152H201.697V37.8182H208V31.5152Z",
    fill: "#0B0C0D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 37.8182H0V44.1212H6.30303V37.8182Z",
    fill: "#0B0C0D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 37.8182H6.30303V44.1212H12.6061V37.8182Z",
    fill: "#0B0C0D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 37.8182H12.6061V44.1212H18.9091V37.8182Z",
    fill: "#0B0C0D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 37.8182H18.9091V44.1212H25.2121V37.8182Z",
    fill: "#0B0C0D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 37.8182H25.2121V44.1212H31.5152V37.8182Z",
    fill: "#0B0C0D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 37.8182H31.5152V44.1212H37.8182V37.8182Z",
    fill: "#0B0C0D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 37.8182H37.8182V44.1212H44.1212V37.8182Z",
    fill: "#0B0C0D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 37.8182H50.4242V44.1212H56.7273V37.8182Z",
    fill: "#0B0C0D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 37.8182H63.0303V44.1212H69.3333V37.8182Z",
    fill: "#0B0C0D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 37.8182H75.6364V44.1212H81.9394V37.8182Z",
    fill: "#0B0C0D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 37.8182H88.2424V44.1212H94.5455V37.8182Z",
    fill: "#0B0C0D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 37.8182H100.848V44.1212H107.152V37.8182Z",
    fill: "#0B0C0D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 37.8182H113.455V44.1212H119.758L119.758 37.8182Z",
    fill: "#0B0C0D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 37.8182H126.061V44.1212H132.364V37.8182Z",
    fill: "#0B0C0D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 37.8182H138.667V44.1212H144.97V37.8182Z",
    fill: "#0B0C0D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 37.8182H151.273V44.1212H157.576V37.8182Z",
    fill: "#0B0C0D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 37.8182H163.879V44.1212H170.182V37.8182Z",
    fill: "#0B0C0D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 37.8182H170.182V44.1212H176.485V37.8182Z",
    fill: "#0B0C0D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 37.8182H176.485V44.1212H182.788V37.8182Z",
    fill: "#0B0C0D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 37.8182H182.788V44.1212H189.091V37.8182Z",
    fill: "#0B0C0D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 37.8182H189.091V44.1212H195.394V37.8182Z",
    fill: "#0B0C0D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 37.8182H195.394V44.1212H201.697V37.8182Z",
    fill: "#0B0C0D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M208 37.8182H201.697V44.1212H208V37.8182Z",
    fill: "#0B0C0D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 44.1212H50.4242V50.4242H56.7273V44.1212Z",
    fill: "#0B0C0D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 44.1212H63.0303V50.4242H69.3333V44.1212Z",
    fill: "#0B0C0D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 44.1212H75.6364V50.4242H81.9394V44.1212Z",
    fill: "#0B0C0D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 44.1212H94.5455V50.4242H100.848V44.1212Z",
    fill: "#0B0C0D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 44.1212H100.848V50.4242H107.152V44.1212Z",
    fill: "#0B0C0D"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 44.1212H119.758L119.758 50.4242H126.061V44.1212Z",
    fill: "#0B0C0D"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 44.1212H126.061V50.4242H132.364V44.1212Z",
    fill: "#0B0C0D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 44.1212H132.364V50.4242H138.667V44.1212Z",
    fill: "#0B0C0D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 44.1212H138.667V50.4242H144.97V44.1212Z",
    fill: "#0B0C0D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 44.1212H144.97V50.4242H151.273V44.1212Z",
    fill: "#0B0C0D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 44.1212H151.273V50.4242H157.576V44.1212Z",
    fill: "#0B0C0D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 50.4242H0V56.7273H6.30303V50.4242Z",
    fill: "#0B0C0D"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 50.4242H6.30303V56.7273H12.6061V50.4242Z",
    fill: "#0B0C0D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 50.4242H18.9091V56.7273H25.2121V50.4242Z",
    fill: "#0B0C0D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 50.4242H37.8182V56.7273H44.1212V50.4242Z",
    fill: "#0B0C0D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 50.4242H44.1212V56.7273H50.4242V50.4242Z",
    fill: "#0B0C0D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 50.4242H56.7273V56.7273H63.0303V50.4242Z",
    fill: "#0B0C0D"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 50.4242H69.3333V56.7273H75.6364V50.4242Z",
    fill: "#0B0C0D"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 50.4242H75.6364V56.7273H81.9394V50.4242Z",
    fill: "#0B0C0D"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 50.4242H81.9394V56.7273H88.2424V50.4242Z",
    fill: "#0B0C0D"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 50.4242H100.848V56.7273H107.152V50.4242Z",
    fill: "#0B0C0D"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 50.4242H107.152V56.7273H113.455V50.4242Z",
    fill: "#0B0C0D"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 50.4242H119.758V56.7273H126.061V50.4242Z",
    fill: "#0B0C0D"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 50.4242H132.364V56.7273H138.667V50.4242Z",
    fill: "#0B0C0D"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 50.4242H138.667V56.7273H144.97V50.4242Z",
    fill: "#0B0C0D"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 50.4242H151.273V56.7273H157.576V50.4242Z",
    fill: "#0B0C0D"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 50.4242H157.576V56.7273H163.879V50.4242Z",
    fill: "#0B0C0D"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 50.4242H163.879V56.7273H170.182V50.4242Z",
    fill: "#0B0C0D"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 50.4242H170.182V56.7273H176.485V50.4242Z",
    fill: "#0B0C0D"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 50.4242H182.788V56.7273H189.091V50.4242Z",
    fill: "#0B0C0D"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 50.4242H189.091V56.7273H195.394V50.4242Z",
    fill: "#0B0C0D"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M208 50.4242H201.697V56.7273H208V50.4242Z",
    fill: "#0B0C0D"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 56.7273H12.6061V63.0303H18.9091V56.7273Z",
    fill: "#0B0C0D"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 56.7273H25.2121V63.0303H31.5152V56.7273Z",
    fill: "#0B0C0D"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 56.7273H31.5152V63.0303H37.8182V56.7273Z",
    fill: "#0B0C0D"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 56.7273H44.1212V63.0303H50.4242V56.7273Z",
    fill: "#0B0C0D"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 56.7273H50.4242V63.0303H56.7273V56.7273Z",
    fill: "#0B0C0D"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 56.7273H69.3333V63.0303H75.6364V56.7273Z",
    fill: "#0B0C0D"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 56.7273H75.6364V63.0303H81.9394V56.7273Z",
    fill: "#0B0C0D"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 56.7273H88.2424V63.0303H94.5455V56.7273Z",
    fill: "#0B0C0D"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 56.7273H100.848V63.0303H107.152V56.7273Z",
    fill: "#0B0C0D"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 56.7273H113.455V63.0303H119.758L119.758 56.7273Z",
    fill: "#0B0C0D"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 56.7273H119.758L119.758 63.0303H126.061V56.7273Z",
    fill: "#0B0C0D"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 56.7273H132.364V63.0303H138.667V56.7273Z",
    fill: "#0B0C0D"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 56.7273H138.667V63.0303H144.97V56.7273Z",
    fill: "#0B0C0D"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 56.7273H151.273V63.0303H157.576V56.7273Z",
    fill: "#0B0C0D"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 56.7273H163.879V63.0303H170.182V56.7273Z",
    fill: "#0B0C0D"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 56.7273H170.182V63.0303H176.485V56.7273Z",
    fill: "#0B0C0D"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 56.7273H182.788V63.0303H189.091V56.7273Z",
    fill: "#0B0C0D"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 56.7273H195.394V63.0303H201.697V56.7273Z",
    fill: "#0B0C0D"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 63.0303H0V69.3333H6.30303V63.0303Z",
    fill: "#0B0C0D"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 63.0303H6.30303V69.3333H12.6061V63.0303Z",
    fill: "#0B0C0D"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 63.0303H12.6061V69.3333H18.9091V63.0303Z",
    fill: "#0B0C0D"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 63.0303H25.2121V69.3333H31.5152V63.0303Z",
    fill: "#0B0C0D"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 63.0303H37.8182V69.3333H44.1212V63.0303Z",
    fill: "#0B0C0D"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 63.0303H44.1212V69.3333H50.4242V63.0303Z",
    fill: "#0B0C0D"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 63.0303H56.7273V69.3333H63.0303V63.0303Z",
    fill: "#0B0C0D"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 63.0303H81.9394V69.3333H88.2424V63.0303Z",
    fill: "#0B0C0D"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 63.0303H94.5455V69.3333H100.848V63.0303Z",
    fill: "#0B0C0D"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 63.0303H100.848V69.3333H107.152V63.0303Z",
    fill: "#0B0C0D"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 63.0303H113.455V69.3333H119.758V63.0303Z",
    fill: "#0B0C0D"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 63.0303H119.758V69.3333H126.061V63.0303Z",
    fill: "#0B0C0D"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 63.0303H126.061V69.3333H132.364V63.0303Z",
    fill: "#0B0C0D"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 63.0303H138.667V69.3333H144.97V63.0303Z",
    fill: "#0B0C0D"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 63.0303H144.97V69.3333H151.273V63.0303Z",
    fill: "#0B0C0D"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 63.0303H157.576V69.3333H163.879V63.0303Z",
    fill: "#0B0C0D"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 63.0303H163.879V69.3333H170.182V63.0303Z",
    fill: "#0B0C0D"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 63.0303H182.788V69.3333H189.091V63.0303Z",
    fill: "#0B0C0D"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 63.0303H189.091V69.3333H195.394V63.0303Z",
    fill: "#0B0C0D"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 63.0303H195.394V69.3333H201.697V63.0303Z",
    fill: "#0B0C0D"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 69.3333H0V75.6364H6.30303V69.3333Z",
    fill: "#0B0C0D"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 69.3333H6.30303V75.6364H12.6061V69.3333Z",
    fill: "#0B0C0D"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 69.3333H12.6061V75.6364H18.9091V69.3333Z",
    fill: "#0B0C0D"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 69.3333H18.9091V75.6364H25.2121V69.3333Z",
    fill: "#0B0C0D"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 69.3333H31.5152V75.6364H37.8182V69.3333Z",
    fill: "#0B0C0D"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 69.3333H56.7273V75.6364H63.0303V69.3333Z",
    fill: "#0B0C0D"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 69.3333H63.0303V75.6364H69.3333V69.3333Z",
    fill: "#0B0C0D"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 69.3333H100.848V75.6364H107.152V69.3333Z",
    fill: "#0B0C0D"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 69.3333H107.152V75.6364H113.455V69.3333Z",
    fill: "#0B0C0D"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 69.3333H119.758L119.758 75.6364H126.061V69.3333Z",
    fill: "#0B0C0D"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 69.3333H126.061V75.6364H132.364V69.3333Z",
    fill: "#0B0C0D"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 69.3333H138.667V75.6364H144.97V69.3333Z",
    fill: "#0B0C0D"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 69.3333H144.97V75.6364H151.273V69.3333Z",
    fill: "#0B0C0D"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 69.3333H151.273V75.6364H157.576V69.3333Z",
    fill: "#0B0C0D"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 69.3333H163.879V75.6364H170.182V69.3333Z",
    fill: "#0B0C0D"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 69.3333H170.182V75.6364H176.485V69.3333Z",
    fill: "#0B0C0D"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 69.3333H176.485V75.6364H182.788V69.3333Z",
    fill: "#0B0C0D"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 69.3333H189.091V75.6364H195.394V69.3333Z",
    fill: "#0B0C0D"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 69.3333H195.394V75.6364H201.697V69.3333Z",
    fill: "#0B0C0D"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M208 69.3333H201.697V75.6364H208V69.3333Z",
    fill: "#0B0C0D"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 75.6364H0V81.9394H6.30303V75.6364Z",
    fill: "#0B0C0D"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 75.6364H6.30303V81.9394H12.6061V75.6364Z",
    fill: "#0B0C0D"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 75.6364H25.2121V81.9394H31.5152V75.6364Z",
    fill: "#0B0C0D"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 75.6364H31.5152V81.9394H37.8182V75.6364Z",
    fill: "#0B0C0D"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 75.6364H37.8182V81.9394H44.1212V75.6364Z",
    fill: "#0B0C0D"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 75.6364H50.4242V81.9394H56.7273V75.6364Z",
    fill: "#0B0C0D"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 75.6364H75.6364V81.9394H81.9394V75.6364Z",
    fill: "#0B0C0D"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 75.6364H88.2424V81.9394H94.5455V75.6364Z",
    fill: "#0B0C0D"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 75.6364H94.5455V81.9394H100.848V75.6364Z",
    fill: "#0B0C0D"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 75.6364H157.576V81.9394H163.879V75.6364Z",
    fill: "#0B0C0D"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 75.6364H163.879V81.9394H170.182V75.6364Z",
    fill: "#0B0C0D"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M208 75.6364H201.697V81.9394H208V75.6364Z",
    fill: "#0B0C0D"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 81.9394H12.6061V88.2424H18.9091V81.9394Z",
    fill: "#0B0C0D"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 81.9394H25.2121V88.2424H31.5152V81.9394Z",
    fill: "#0B0C0D"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 81.9394H56.7273V88.2424H63.0303V81.9394Z",
    fill: "#0B0C0D"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 81.9394H63.0303V88.2424H69.3333V81.9394Z",
    fill: "#0B0C0D"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 81.9394H81.9394V88.2424H88.2424V81.9394Z",
    fill: "#0B0C0D"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 81.9394H107.152V88.2424H113.455V81.9394Z",
    fill: "#0B0C0D"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 81.9394H113.455V88.2424H119.758V81.9394Z",
    fill: "#0B0C0D"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 81.9394H126.061V88.2424H132.364V81.9394Z",
    fill: "#0B0C0D"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 81.9394H132.364V88.2424H138.667V81.9394Z",
    fill: "#0B0C0D"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 81.9394H138.667V88.2424H144.97V81.9394Z",
    fill: "#0B0C0D"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 81.9394H157.576V88.2424H163.879V81.9394Z",
    fill: "#0B0C0D"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 81.9394H182.788V88.2424H189.091V81.9394Z",
    fill: "#0B0C0D"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 81.9394H195.394V88.2424H201.697V81.9394Z",
    fill: "#0B0C0D"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 88.2424H6.30303V94.5455H12.6061V88.2424Z",
    fill: "#0B0C0D"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 88.2424H12.6061V94.5455H18.9091V88.2424Z",
    fill: "#0B0C0D"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 88.2424H31.5152V94.5455H37.8182V88.2424Z",
    fill: "#0B0C0D"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 88.2424H37.8182V94.5455H44.1212V88.2424Z",
    fill: "#0B0C0D"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 88.2424H50.4242V94.5455H56.7273V88.2424Z",
    fill: "#0B0C0D"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 88.2424H56.7273V94.5455H63.0303V88.2424Z",
    fill: "#0B0C0D"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 88.2424H75.6364V94.5455H81.9394V88.2424Z",
    fill: "#0B0C0D"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 88.2424H81.9394V94.5455H88.2424V88.2424Z",
    fill: "#0B0C0D"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 88.2424H88.2424V94.5455H94.5455V88.2424Z",
    fill: "#0B0C0D"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 88.2424H94.5455V94.5455H100.848V88.2424Z",
    fill: "#0B0C0D"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 88.2424H107.152V94.5455H113.455V88.2424Z",
    fill: "#0B0C0D"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 88.2424H113.455V94.5455H119.758V88.2424Z",
    fill: "#0B0C0D"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 88.2424H132.364V94.5455H138.667V88.2424Z",
    fill: "#0B0C0D"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 88.2424H157.576V94.5455H163.879V88.2424Z",
    fill: "#0B0C0D"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 88.2424H163.879V94.5455H170.182V88.2424Z",
    fill: "#0B0C0D"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 88.2424H182.788V94.5455H189.091V88.2424Z",
    fill: "#0B0C0D"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 88.2424H189.091V94.5455H195.394V88.2424Z",
    fill: "#0B0C0D"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 88.2424H195.394V94.5455H201.697V88.2424Z",
    fill: "#0B0C0D"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M208 88.2424H201.697V94.5455H208V88.2424Z",
    fill: "#0B0C0D"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 94.5455H18.9091V100.848H25.2121V94.5455Z",
    fill: "#0B0C0D"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 94.5455H31.5152V100.848H37.8182V94.5455Z",
    fill: "#0B0C0D"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 94.5455H44.1212V100.848H50.4242V94.5455Z",
    fill: "#0B0C0D"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 94.5455H50.4242V100.848H56.7273V94.5455Z",
    fill: "#0B0C0D"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 94.5455H75.6364V100.848H81.9394V94.5455Z",
    fill: "#0B0C0D"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 94.5455H94.5455V100.848H100.848V94.5455Z",
    fill: "#0B0C0D"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 94.5455H107.152V100.848H113.455V94.5455Z",
    fill: "#0B0C0D"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 94.5455H113.455V100.848H119.758V94.5455Z",
    fill: "#0B0C0D"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 94.5455H132.364V100.848H138.667V94.5455Z",
    fill: "#0B0C0D"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 94.5455H138.667V100.848H144.97V94.5455Z",
    fill: "#0B0C0D"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 94.5455H144.97V100.848H151.273V94.5455Z",
    fill: "#0B0C0D"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 94.5455H157.576V100.848H163.879V94.5455Z",
    fill: "#0B0C0D"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 94.5455H176.485V100.848H182.788V94.5455Z",
    fill: "#0B0C0D"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 94.5455H189.091V100.848H195.394V94.5455Z",
    fill: "#0B0C0D"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 100.848H12.6061V107.152H18.9091V100.848Z",
    fill: "#0B0C0D"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 100.848H25.2121V107.152H31.5152V100.848Z",
    fill: "#0B0C0D"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 100.848H31.5152V107.152H37.8182V100.848Z",
    fill: "#0B0C0D"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 100.848H37.8182V107.152H44.1212V100.848Z",
    fill: "#0B0C0D"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 100.848H44.1212V107.152H50.4242V100.848Z",
    fill: "#0B0C0D"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 100.848H56.7273V107.152H63.0303V100.848Z",
    fill: "#0B0C0D"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 100.848H69.3333V107.152H75.6364V100.848Z",
    fill: "#0B0C0D"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 100.848H75.6364V107.152H81.9394V100.848Z",
    fill: "#0B0C0D"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 100.848H100.848V107.152H107.152V100.848Z",
    fill: "#0B0C0D"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 100.848H113.455V107.152H119.758V100.848Z",
    fill: "#0B0C0D"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 100.848H126.061V107.152H132.364V100.848Z",
    fill: "#0B0C0D"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 100.848H132.364V107.152H138.667V100.848Z",
    fill: "#0B0C0D"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 100.848H157.576V107.152H163.879V100.848Z",
    fill: "#0B0C0D"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 100.848H170.182V107.152H176.485V100.848Z",
    fill: "#0B0C0D"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 100.848H176.485V107.152H182.788V100.848Z",
    fill: "#0B0C0D"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 100.848H182.788V107.152H189.091V100.848Z",
    fill: "#0B0C0D"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 100.848H189.091V107.152H195.394V100.848Z",
    fill: "#0B0C0D"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M208 100.848H201.697V107.152H208V100.848Z",
    fill: "#0B0C0D"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 107.152H6.30303V113.455H12.6061V107.152Z",
    fill: "#0B0C0D"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 107.152H44.1212V113.455H50.4242V107.152Z",
    fill: "#0B0C0D"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 107.152H50.4242V113.455H56.7273V107.152Z",
    fill: "#0B0C0D"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 107.152H56.7273V113.455H63.0303V107.152Z",
    fill: "#0B0C0D"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 107.152H69.3333V113.455H75.6364V107.152Z",
    fill: "#0B0C0D"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 107.152H88.2424V113.455H94.5455V107.152Z",
    fill: "#0B0C0D"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 107.152H119.758L119.758 113.455H126.061V107.152Z",
    fill: "#0B0C0D"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 107.152H132.364V113.455H138.667V107.152Z",
    fill: "#0B0C0D"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 107.152H151.273V113.455H157.576V107.152Z",
    fill: "#0B0C0D"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 107.152H163.879V113.455H170.182V107.152Z",
    fill: "#0B0C0D"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 107.152H170.182V113.455H176.485V107.152Z",
    fill: "#0B0C0D"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 107.152H176.485V113.455H182.788V107.152Z",
    fill: "#0B0C0D"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 107.152H189.091V113.455H195.394V107.152Z",
    fill: "#0B0C0D"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 107.152H195.394V113.455H201.697V107.152Z",
    fill: "#0B0C0D"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M208 107.152H201.697V113.455H208V107.152Z",
    fill: "#0B0C0D"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 113.455H0V119.758H6.30303V113.455Z",
    fill: "#0B0C0D"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 113.455H12.6061V119.758H18.9091V113.455Z",
    fill: "#0B0C0D"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 113.455H18.9091V119.758H25.2121V113.455Z",
    fill: "#0B0C0D"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 113.455H25.2121V119.758H31.5152V113.455Z",
    fill: "#0B0C0D"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 113.455H31.5152V119.758H37.8182V113.455Z",
    fill: "#0B0C0D"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 113.455H37.8182V119.758H44.1212V113.455Z",
    fill: "#0B0C0D"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 113.455H44.1212V119.758H50.4242V113.455Z",
    fill: "#0B0C0D"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 113.455H56.7273V119.758H63.0303V113.455Z",
    fill: "#0B0C0D"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 113.455H63.0303V119.758H69.3333V113.455Z",
    fill: "#0B0C0D"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 113.455H88.2424V119.758H94.5455V113.455Z",
    fill: "#0B0C0D"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 113.455H100.848V119.758H107.152V113.455Z",
    fill: "#0B0C0D"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 113.455H113.455V119.758H119.758L119.758 113.455Z",
    fill: "#0B0C0D"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 113.455H119.758L119.758 119.758H126.061V113.455Z",
    fill: "#0B0C0D"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 113.455H138.667V119.758H144.97V113.455Z",
    fill: "#0B0C0D"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 113.455H163.879V119.758H170.182V113.455Z",
    fill: "#0B0C0D"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 113.455H170.182V119.758H176.485V113.455Z",
    fill: "#0B0C0D"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 113.455H176.485V119.758H182.788V113.455Z",
    fill: "#0B0C0D"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 113.455H195.394V119.758H201.697V113.455Z",
    fill: "#0B0C0D"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 119.758H0V126.061H6.30303V119.758Z",
    fill: "#0B0C0D"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 119.758H18.9091V126.061H25.2121V119.758Z",
    fill: "#0B0C0D"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 119.758H44.1212V126.061H50.4242V119.758Z",
    fill: "#0B0C0D"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 119.758H56.7273V126.061H63.0303V119.758Z",
    fill: "#0B0C0D"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 119.758H88.2424V126.061H94.5455V119.758Z",
    fill: "#0B0C0D"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 119.758H100.848V126.061H107.152V119.758Z",
    fill: "#0B0C0D"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 119.758H119.758L119.758 126.061H126.061V119.758Z",
    fill: "#0B0C0D"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 119.758L132.364 119.758V126.061H138.667V119.758Z",
    fill: "#0B0C0D"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 119.758L157.576 119.758V126.061H163.879V119.758Z",
    fill: "#0B0C0D"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 119.758H163.879V126.061H170.182V119.758Z",
    fill: "#0B0C0D"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M208 119.758L201.697 119.758V126.061H208V119.758Z",
    fill: "#0B0C0D"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 126.061H0V132.364H6.30303V126.061Z",
    fill: "#0B0C0D"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 126.061H12.6061V132.364H18.9091V126.061Z",
    fill: "#0B0C0D"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 126.061H37.8182V132.364H44.1212V126.061Z",
    fill: "#0B0C0D"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 126.061H56.7273V132.364H63.0303V126.061Z",
    fill: "#0B0C0D"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 126.061H81.9394V132.364H88.2424V126.061Z",
    fill: "#0B0C0D"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 126.061H88.2424V132.364H94.5455V126.061Z",
    fill: "#0B0C0D"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 126.061H100.848V132.364H107.152V126.061Z",
    fill: "#0B0C0D"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 126.061H107.152V132.364H113.455V126.061Z",
    fill: "#0B0C0D"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 126.061H126.061V132.364H132.364V126.061Z",
    fill: "#0B0C0D"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 126.061H144.97V132.364H151.273V126.061Z",
    fill: "#0B0C0D"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 126.061H157.576V132.364H163.879V126.061Z",
    fill: "#0B0C0D"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 126.061H163.879V132.364H170.182V126.061Z",
    fill: "#0B0C0D"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 126.061H170.182V132.364H176.485V126.061Z",
    fill: "#0B0C0D"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 126.061H189.091V132.364H195.394V126.061Z",
    fill: "#0B0C0D"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 132.364H0V138.667H6.30303V132.364Z",
    fill: "#0B0C0D"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 132.364H6.30303V138.667H12.6061V132.364Z",
    fill: "#0B0C0D"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 132.364H50.4242V138.667H56.7273V132.364Z",
    fill: "#0B0C0D"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 132.364H56.7273V138.667H63.0303V132.364Z",
    fill: "#0B0C0D"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 132.364H94.5455V138.667H100.848V132.364Z",
    fill: "#0B0C0D"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 132.364H100.848V138.667H107.152V132.364Z",
    fill: "#0B0C0D"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 132.364H126.061V138.667H132.364V132.364Z",
    fill: "#0B0C0D"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 132.364H132.364V138.667H138.667V132.364Z",
    fill: "#0B0C0D"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 132.364H170.182V138.667H176.485V132.364Z",
    fill: "#0B0C0D"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 132.364H176.485V138.667H182.788V132.364Z",
    fill: "#0B0C0D"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 132.364H182.788V138.667H189.091V132.364Z",
    fill: "#0B0C0D"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 132.364H189.091V138.667H195.394V132.364Z",
    fill: "#0B0C0D"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M208 132.364H201.697V138.667H208V132.364Z",
    fill: "#0B0C0D"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 138.667H6.30303V144.97H12.6061V138.667Z",
    fill: "#0B0C0D"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 138.667H25.2121V144.97H31.5152V138.667Z",
    fill: "#0B0C0D"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 138.667H31.5152V144.97H37.8182V138.667Z",
    fill: "#0B0C0D"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 138.667H37.8182V144.97H44.1212V138.667Z",
    fill: "#0B0C0D"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 138.667H44.1212V144.97H50.4242V138.667Z",
    fill: "#0B0C0D"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 138.667H56.7273V144.97H63.0303V138.667Z",
    fill: "#0B0C0D"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 138.667H63.0303V144.97H69.3333V138.667Z",
    fill: "#0B0C0D"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 138.667H69.3333V144.97H75.6364V138.667Z",
    fill: "#0B0C0D"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 138.667H81.9394V144.97H88.2424V138.667Z",
    fill: "#0B0C0D"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 138.667H88.2424V144.97H94.5455V138.667Z",
    fill: "#0B0C0D"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 138.667H100.848V144.97H107.152V138.667Z",
    fill: "#0B0C0D"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 138.667H126.061V144.97H132.364V138.667Z",
    fill: "#0B0C0D"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 138.667H132.364V144.97H138.667V138.667Z",
    fill: "#0B0C0D"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 138.667H144.97V144.97H151.273V138.667Z",
    fill: "#0B0C0D"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 138.667H151.273V144.97H157.576V138.667Z",
    fill: "#0B0C0D"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 138.667H163.879V144.97H170.182V138.667Z",
    fill: "#0B0C0D"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 138.667H189.091V144.97H195.394V138.667Z",
    fill: "#0B0C0D"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 144.97H0V151.273H6.30303V144.97Z",
    fill: "#0B0C0D"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 144.97H6.30303V151.273H12.6061V144.97Z",
    fill: "#0B0C0D"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 144.97H12.6061V151.273H18.9091V144.97Z",
    fill: "#0B0C0D"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 144.97H18.9091V151.273H25.2121V144.97Z",
    fill: "#0B0C0D"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 144.97H44.1212V151.273H50.4242V144.97Z",
    fill: "#0B0C0D"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 144.97H56.7273V151.273H63.0303V144.97Z",
    fill: "#0B0C0D"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 144.97H63.0303V151.273H69.3333V144.97Z",
    fill: "#0B0C0D"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 144.97H69.3333V151.273H75.6364V144.97Z",
    fill: "#0B0C0D"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 144.97H100.848V151.273H107.152V144.97Z",
    fill: "#0B0C0D"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 144.97H107.152V151.273H113.455V144.97Z",
    fill: "#0B0C0D"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 144.97H119.758V151.273H126.061V144.97Z",
    fill: "#0B0C0D"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 144.97H132.364V151.273H138.667V144.97Z",
    fill: "#0B0C0D"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 144.97H138.667V151.273H144.97V144.97Z",
    fill: "#0B0C0D"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 144.97H163.879V151.273H170.182V144.97Z",
    fill: "#0B0C0D"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 144.97H170.182V151.273H176.485V144.97Z",
    fill: "#0B0C0D"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 144.97H176.485V151.273H182.788V144.97Z",
    fill: "#0B0C0D"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 151.273H12.6061V157.576H18.9091V151.273Z",
    fill: "#0B0C0D"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 151.273H31.5152V157.576H37.8182V151.273Z",
    fill: "#0B0C0D"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 151.273H37.8182V157.576H44.1212V151.273Z",
    fill: "#0B0C0D"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4242 151.273H44.1212V157.576H50.4242V151.273Z",
    fill: "#0B0C0D"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 151.273H56.7273V157.576H63.0303V151.273Z",
    fill: "#0B0C0D"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 151.273H63.0303V157.576H69.3333V151.273Z",
    fill: "#0B0C0D"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 151.273H88.2424V157.576H94.5455V151.273Z",
    fill: "#0B0C0D"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 151.273H100.848V157.576H107.152V151.273Z",
    fill: "#0B0C0D"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 151.273H107.152V157.576H113.455V151.273Z",
    fill: "#0B0C0D"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 151.273H113.455V157.576H119.758L119.758 151.273Z",
    fill: "#0B0C0D"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 151.273H126.061V157.576H132.364V151.273Z",
    fill: "#0B0C0D"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 151.273H132.364V157.576H138.667V151.273Z",
    fill: "#0B0C0D"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 151.273H138.667V157.576H144.97V151.273Z",
    fill: "#0B0C0D"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 151.273H151.273V157.576H157.576V151.273Z",
    fill: "#0B0C0D"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 151.273H157.576V157.576H163.879V151.273Z",
    fill: "#0B0C0D"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 151.273H163.879V157.576H170.182V151.273Z",
    fill: "#0B0C0D"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 151.273H170.182V157.576H176.485V151.273Z",
    fill: "#0B0C0D"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 151.273H176.485V157.576H182.788V151.273Z",
    fill: "#0B0C0D"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 151.273H189.091V157.576H195.394V151.273Z",
    fill: "#0B0C0D"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 151.273H195.394V157.576H201.697V151.273Z",
    fill: "#0B0C0D"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 157.576H63.0303V163.879H69.3333V157.576Z",
    fill: "#0B0C0D"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 157.576H75.6364V163.879H81.9394V157.576Z",
    fill: "#0B0C0D"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 157.576H94.5455V163.879H100.848V157.576Z",
    fill: "#0B0C0D"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 157.576H100.848V163.879H107.152V157.576Z",
    fill: "#0B0C0D"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 157.576H107.152V163.879H113.455V157.576Z",
    fill: "#0B0C0D"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 157.576H119.758L119.758 163.879H126.061V157.576Z",
    fill: "#0B0C0D"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 157.576H151.273V163.879H157.576V157.576Z",
    fill: "#0B0C0D"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 157.576H176.485V163.879H182.788V157.576Z",
    fill: "#0B0C0D"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 157.576H189.091V163.879H195.394V157.576Z",
    fill: "#0B0C0D"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 157.576H195.394V163.879H201.697V157.576Z",
    fill: "#0B0C0D"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M208 157.576H201.697V163.879H208V157.576Z",
    fill: "#0B0C0D"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 163.879H0V170.182H6.30303V163.879Z",
    fill: "#0B0C0D"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 163.879H6.30303V170.182H12.6061V163.879Z",
    fill: "#0B0C0D"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 163.879H12.6061V170.182H18.9091V163.879Z",
    fill: "#0B0C0D"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 163.879H18.9091V170.182H25.2121V163.879Z",
    fill: "#0B0C0D"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 163.879H25.2121V170.182H31.5152V163.879Z",
    fill: "#0B0C0D"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 163.879H31.5152V170.182H37.8182V163.879Z",
    fill: "#0B0C0D"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 163.879H37.8182V170.182H44.1212V163.879Z",
    fill: "#0B0C0D"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 163.879H50.4242V170.182H56.7273V163.879Z",
    fill: "#0B0C0D"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 163.879H56.7273V170.182H63.0303V163.879Z",
    fill: "#0B0C0D"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 163.879H69.3333V170.182H75.6364V163.879Z",
    fill: "#0B0C0D"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 163.879H88.2424V170.182H94.5455V163.879Z",
    fill: "#0B0C0D"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 163.879H94.5455V170.182H100.848V163.879Z",
    fill: "#0B0C0D"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 163.879H100.848V170.182H107.152V163.879Z",
    fill: "#0B0C0D"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 163.879H107.152V170.182H113.455V163.879Z",
    fill: "#0B0C0D"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 163.879H113.455V170.182H119.758L119.758 163.879Z",
    fill: "#0B0C0D"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 163.879H119.758L119.758 170.182H126.061V163.879Z",
    fill: "#0B0C0D"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 163.879H132.364V170.182H138.667V163.879Z",
    fill: "#0B0C0D"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 163.879H138.667V170.182H144.97V163.879Z",
    fill: "#0B0C0D"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 163.879H151.273V170.182H157.576V163.879Z",
    fill: "#0B0C0D"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 163.879H163.879V170.182H170.182V163.879Z",
    fill: "#0B0C0D"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 163.879H176.485V170.182H182.788V163.879Z",
    fill: "#0B0C0D"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 163.879H189.091V170.182H195.394V163.879Z",
    fill: "#0B0C0D"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 163.879H195.394V170.182H201.697V163.879Z",
    fill: "#0B0C0D"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 170.182H0V176.485H6.30303V170.182Z",
    fill: "#0B0C0D"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 170.182H37.8182V176.485H44.1212V170.182Z",
    fill: "#0B0C0D"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 170.182H56.7273V176.485H63.0303V170.182Z",
    fill: "#0B0C0D"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 170.182H63.0303V176.485H69.3333V170.182Z",
    fill: "#0B0C0D"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 170.182H69.3333V176.485H75.6364V170.182Z",
    fill: "#0B0C0D"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 170.182H75.6364V176.485H81.9394V170.182Z",
    fill: "#0B0C0D"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 170.182H88.2424V176.485H94.5455V170.182Z",
    fill: "#0B0C0D"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 170.182H113.455V176.485H119.758V170.182Z",
    fill: "#0B0C0D"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 170.182H138.667V176.485H144.97V170.182Z",
    fill: "#0B0C0D"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 170.182H151.273V176.485H157.576V170.182Z",
    fill: "#0B0C0D"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 170.182H176.485V176.485H182.788V170.182Z",
    fill: "#0B0C0D"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 170.182H182.788V176.485H189.091V170.182Z",
    fill: "#0B0C0D"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 170.182H189.091V176.485H195.394V170.182Z",
    fill: "#0B0C0D"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 170.182H195.394V176.485H201.697V170.182Z",
    fill: "#0B0C0D"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 176.485H0V182.788H6.30303V176.485Z",
    fill: "#0B0C0D"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 176.485H12.6061V182.788H18.9091V176.485Z",
    fill: "#0B0C0D"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 176.485H18.9091V182.788H25.2121V176.485Z",
    fill: "#0B0C0D"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 176.485H25.2121V182.788H31.5152V176.485Z",
    fill: "#0B0C0D"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 176.485H37.8182V182.788H44.1212V176.485Z",
    fill: "#0B0C0D"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 176.485H63.0303V182.788H69.3333V176.485Z",
    fill: "#0B0C0D"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 176.485H75.6364V182.788H81.9394V176.485Z",
    fill: "#0B0C0D"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 176.485H88.2424V182.788H94.5455V176.485Z",
    fill: "#0B0C0D"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 176.485H100.848V182.788H107.152V176.485Z",
    fill: "#0B0C0D"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 176.485H107.152V182.788H113.455V176.485Z",
    fill: "#0B0C0D"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 176.485H113.455V182.788H119.758V176.485Z",
    fill: "#0B0C0D"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 176.485H119.758V182.788H126.061V176.485Z",
    fill: "#0B0C0D"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 176.485H138.667V182.788H144.97V176.485Z",
    fill: "#0B0C0D"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 176.485H144.97V182.788H151.273V176.485Z",
    fill: "#0B0C0D"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M157.576 176.485H151.273V182.788H157.576V176.485Z",
    fill: "#0B0C0D"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 176.485H157.576V182.788H163.879V176.485Z",
    fill: "#0B0C0D"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 176.485H163.879V182.788H170.182V176.485Z",
    fill: "#0B0C0D"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 176.485H170.182V182.788H176.485V176.485Z",
    fill: "#0B0C0D"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 176.485H176.485V182.788H182.788V176.485Z",
    fill: "#0B0C0D"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 176.485H195.394V182.788H201.697V176.485Z",
    fill: "#0B0C0D"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M208 176.485H201.697V182.788H208V176.485Z",
    fill: "#0B0C0D"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 182.788H0V189.091H6.30303V182.788Z",
    fill: "#0B0C0D"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 182.788H12.6061V189.091H18.9091V182.788Z",
    fill: "#0B0C0D"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 182.788H18.9091V189.091H25.2121V182.788Z",
    fill: "#0B0C0D"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 182.788H25.2121V189.091H31.5152V182.788Z",
    fill: "#0B0C0D"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 182.788H37.8182V189.091H44.1212V182.788Z",
    fill: "#0B0C0D"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 182.788H50.4242V189.091H56.7273V182.788Z",
    fill: "#0B0C0D"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 182.788H56.7273V189.091H63.0303V182.788Z",
    fill: "#0B0C0D"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 182.788H63.0303V189.091H69.3333V182.788Z",
    fill: "#0B0C0D"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 182.788H69.3333V189.091H75.6364V182.788Z",
    fill: "#0B0C0D"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9394 182.788H75.6364V189.091H81.9394V182.788Z",
    fill: "#0B0C0D"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 182.788H81.9394V189.091H88.2424V182.788Z",
    fill: "#0B0C0D"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5455 182.788H88.2424V189.091H94.5455V182.788Z",
    fill: "#0B0C0D"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 182.788H94.5455V189.091H100.848V182.788Z",
    fill: "#0B0C0D"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 182.788H100.848V189.091H107.152V182.788Z",
    fill: "#0B0C0D"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 182.788H107.152V189.091H113.455V182.788Z",
    fill: "#0B0C0D"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 182.788H126.061V189.091H132.364V182.788Z",
    fill: "#0B0C0D"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 182.788H138.667V189.091H144.97V182.788Z",
    fill: "#0B0C0D"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 182.788H144.97V189.091H151.273V182.788Z",
    fill: "#0B0C0D"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M163.879 182.788H157.576V189.091H163.879V182.788Z",
    fill: "#0B0C0D"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 182.788H170.182V189.091H176.485V182.788Z",
    fill: "#0B0C0D"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 182.788H189.091V189.091H195.394V182.788Z",
    fill: "#0B0C0D"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M208 182.788H201.697V189.091H208V182.788Z",
    fill: "#0B0C0D"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 189.091H0V195.394H6.30303V189.091Z",
    fill: "#0B0C0D"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 189.091H12.6061V195.394H18.9091V189.091Z",
    fill: "#0B0C0D"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 189.091H18.9091V195.394H25.2121V189.091Z",
    fill: "#0B0C0D"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 189.091H25.2121V195.394H31.5152V189.091Z",
    fill: "#0B0C0D"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 189.091H37.8182V195.394H44.1212V189.091Z",
    fill: "#0B0C0D"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 189.091H56.7273V195.394H63.0303V189.091Z",
    fill: "#0B0C0D"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M100.848 189.091H94.5455V195.394H100.848V189.091Z",
    fill: "#0B0C0D"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M107.152 189.091H100.848V195.394H107.152V189.091Z",
    fill: "#0B0C0D"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 189.091H113.455V195.394H119.758V189.091Z",
    fill: "#0B0C0D"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 189.091H126.061V195.394H132.364V189.091Z",
    fill: "#0B0C0D"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 189.091H132.364V195.394H138.667V189.091Z",
    fill: "#0B0C0D"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 189.091H138.667V195.394H144.97V189.091Z",
    fill: "#0B0C0D"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M176.485 189.091H170.182V195.394H176.485V189.091Z",
    fill: "#0B0C0D"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 189.091H176.485V195.394H182.788V189.091Z",
    fill: "#0B0C0D"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M195.394 189.091H189.091V195.394H195.394V189.091Z",
    fill: "#0B0C0D"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M208 189.091H201.697V195.394H208V189.091Z",
    fill: "#0B0C0D"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 195.394H0V201.697H6.30303V195.394Z",
    fill: "#0B0C0D"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 195.394H37.8182V201.697H44.1212V195.394Z",
    fill: "#0B0C0D"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 195.394H50.4242V201.697H56.7273V195.394Z",
    fill: "#0B0C0D"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 195.394H63.0303V201.697H69.3333V195.394Z",
    fill: "#0B0C0D"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2424 195.394H81.9394V201.697H88.2424V195.394Z",
    fill: "#0B0C0D"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M119.758 195.394H113.455V201.697H119.758V195.394Z",
    fill: "#0B0C0D"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 195.394H119.758V201.697H126.061V195.394Z",
    fill: "#0B0C0D"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 195.394H138.667V201.697H144.97V195.394Z",
    fill: "#0B0C0D"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30303 201.697H0V208H6.30303V201.697Z",
    fill: "#0B0C0D"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6061 201.697H6.30303V208H12.6061V201.697Z",
    fill: "#0B0C0D"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9091 201.697H12.6061V208H18.9091V201.697Z",
    fill: "#0B0C0D"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2121 201.697H18.9091V208H25.2121V201.697Z",
    fill: "#0B0C0D"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5152 201.697H25.2121V208H31.5152V201.697Z",
    fill: "#0B0C0D"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 201.697H31.5152V208H37.8182V201.697Z",
    fill: "#0B0C0D"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1212 201.697H37.8182V208H44.1212V201.697Z",
    fill: "#0B0C0D"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7273 201.697H50.4242V208H56.7273V201.697Z",
    fill: "#0B0C0D"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0303 201.697H56.7273V208H63.0303V201.697Z",
    fill: "#0B0C0D"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3333 201.697H63.0303V208H69.3333V201.697Z",
    fill: "#0B0C0D"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6364 201.697H69.3333V208H75.6364V201.697Z",
    fill: "#0B0C0D"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M113.455 201.697H107.152V208H113.455V201.697Z",
    fill: "#0B0C0D"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M126.061 201.697H119.758L119.758 208H126.061V201.697Z",
    fill: "#0B0C0D"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 201.697H132.364V208H138.667V201.697Z",
    fill: "#0B0C0D"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M144.97 201.697H138.667V208H144.97V201.697Z",
    fill: "#0B0C0D"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M151.273 201.697H144.97V208H151.273V201.697Z",
    fill: "#0B0C0D"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M182.788 201.697H176.485V208H182.788V201.697Z",
    fill: "#0B0C0D"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 201.697H182.788V208H189.091V201.697Z",
    fill: "#0B0C0D"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M201.697 201.697H195.394V208H201.697V201.697Z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrApp);
export default __webpack_public_path__ + "static/media/qr-app.daaccbc211672d1aa10f67ed44806650.svg";
export { ForwardRef as ReactComponent };